import { Component, OnInit, Input } from '@angular/core';

import { cloneDeep } from 'lodash';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { AbstractControl, ControlEvent } from '../../types/control.types';

@Component({
  selector: 'df-event-group',
  templateUrl: './event-group.component.html',
  styleUrls: ['./event-group.component.css']
})
export class EventGroupComponent implements OnInit {
  @Input()
  get control(): AbstractControl<any> {
    return this._control;
  }
  set control(value: AbstractControl<any>) {
    this._control = value;
    this.init();
  }

  isAdd: boolean;
  currentIndex: number;
  events: Array<ControlEvent>;

  currentEvent: ControlEvent;
  private _control: AbstractControl<any>;

  constructor(private commonConfig: DynamicFormCommonConfig) {}

  ngOnInit(): void {}

  init() {
    this.clearEvent();
    if (!this.control) {
      this.events = [];
    } else {
      this.events = this.control.model[`events`];
      if (!this.events) {
        this.events = this.control.model[`events`] = [];
      }
    }
  }

  // æ¾ç¤ºæ·»å 
  showAdd() {
    this.currentEvent = { groupName: '', name: '', script: '' };
    this.isAdd = true;
  }
  // æ¾ç¤ºç¼è¾
  showEdit(i: number) {
    this.currentEvent = cloneDeep(this.events[i]);
    this.currentIndex = i;
    this.isAdd = false;
  }

  cancel() {
    this.clearEvent();
  }

  save() {
    if (!this.validForm()) {
      return;
    }
    if (this.isAdd) {
      this.add();
    } else {
      this.update();
    }
  }

  add() {
    this.events.push(this.currentEvent);
    this.resetEvent();
  }

  update() {
    this.events[this.currentIndex] = cloneDeep(this.currentEvent);
    this.clearEvent();
  }

  delete(i: number) {
    this.events.splice(i, 1);
    this.clearEvent();
  }

  private validForm() {
    const reg = /^[A-Za-z]+[A-Za-z0-9]*/;
    if (!reg.test(this.currentEvent.name)) {
      this.commonConfig.log.error(`äºä»¶åç§°å¿é¡»ä»¥å­æ¯å¼å¤´,å­æ¯åæ°å­ç»å`);
      return false;
    }
    return true;
  }
  // éç½®event
  private resetEvent() {
    this.currentEvent = { groupName: '', name: '', script: '' };
  }

  // æ¸ç©ºevent
  private clearEvent() {
    this.currentEvent = undefined;
    this.currentIndex = undefined;
  }
}
